var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Input } from '../Form/Input';
export const EditableTableCell = (_a) => {
    // React.useEffect(() => {
    //   setState((s) => ({
    //     ...s,
    //     edited: { ...s.edited, [id]: value || '' },
    //     confirmed: { ...s.confirmed, [id]: value || '' },
    //   }));
    // }, []);
    var { className, cell: { value } } = _a, _b = _a.row, { index, cells, setState, state } = _b, row = __rest(_b, ["index", "cells", "setState", "state"]), { column: { id }, onUpdate, autoResetRowState } = _a, props = __rest(_a, ["className", "cell", "row", "column", "onUpdate", "autoResetRowState"]);
    const onChange = (e) => {
        const tempVal = e.target.value;
        console.log('ON CHANGE: ', id);
        setState((s) => (Object.assign(Object.assign({}, s), { edited: Object.assign(Object.assign({}, s.edited), { [id]: tempVal || '' }) })));
    };
    return (React.createElement(React.Fragment, null, props.editable ? (React.createElement(Input, { name: props.name, value: state && state.edited && state.edited[id] !== undefined
            ? state.edited[id]
            : (state === null || state === void 0 ? void 0 : state.confirmed) && (state === null || state === void 0 ? void 0 : state.confirmed[id]) !== undefined
                ? state.confirmed[id]
                : value !== undefined
                    ? value
                    : '', onChange: onChange })) : (React.createElement(React.Fragment, null, (state === null || state === void 0 ? void 0 : state.edited) && state.edited[id] !== undefined
        ? state.edited[id]
        : (state === null || state === void 0 ? void 0 : state.confirmed) && (state === null || state === void 0 ? void 0 : state.confirmed[id]) !== undefined
            ? state.confirmed[id]
            : value !== undefined
                ? value
                : ''))));
};
//# sourceMappingURL=EditableTableCell.js.map